import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import GeneralHandler from '../../modules/General';
import SplitRows from '../../components/general/SplitRow.js';
import OptionColumn from '../../components/general/OptionColumn.js';
import moment from 'moment';
import LoadingSmall from '../../components/LoadingSmall.js';
import General from '../../modules/General';

class Settings extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			'isLoading':true,
			'accept_cancel':false,
			'isCancelling':false,
			'isResuming':false,
			'next_billing_period':false,
			'invoices':[],
		}

		this.handleResume = this.handleResume.bind(this);
		this.handleChangePlan = this.handleChangePlan.bind(this);
		this.handleCard = this.handleCard.bind(this);
	}

	handleCard() {
		this.props.router.push(General.Link('/settings/billing/card'));
	}

	handleChangePlan() {
		this.props.router.push(General.Link('/settings/billing/plan'));
	}

	handleResume() {
		this.setState({
			isResuming:true
		});
		axios.post('/subscriptions/resume').then(res => {
			GeneralHandler.fetchGeneral().then(res => {
				this.setState({
					isResuming:true
				});
			});
		});


	}


	componentWillMount() {
        this.props.router.push(General.Link('/settings/billing/subscribe'));
		return false;
    }

	renderSubscribed() {
		return (
			<div>
			{this.props.general.account.grace_period ?
						null
					:
			<OptionColumn title="Plan" description="The plan you're currently subscribed to.">
				{
                    this.props.general.account.downgrade_package ?
					<div className="alert col-sm-12 dark alert-icon alert-info alert-dismissible" role="alert">
						<i className="icon wb-info" aria-hidden="true"></i> You are now on plan <strong>{this.props.general.account.downgrade_package.name}</strong>. You will still have access to all the features of plan <strong>{this.props.general.account.package.name}</strong> until <strong>{moment(this.state.next_billing_period).format('DD.MM.YYYY')}</strong>.
					</div>:null
				}
				<table className="table table-bordered">
                    <thead>
                        <tr className="table-active">
                            <th>Package</th>
                            <th>Description</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{this.props.general.account.downgrade_package ? this.props.general.account.downgrade_package.name:this.props.general.account.package.name}</td>
                            <td>
                                <p>- Billed each month</p>

                                {this.props.general.account.country == 'Norway' ? <p>- Priser eks mva</p>:''}
								{
									this.state.next_billing_period ?
										<p>- Next billing period: {moment(this.state.next_billing_period).format('DD.MM.YYYY')}</p>:false
                                }
                                </td>
                            <td>
                            <strong>
                                {this.props.general.account.country == 'Norway' ?
                                    <p>{this.props.general.account.downgrade_package ? this.props.general.account.downgrade_package.price_norwegian:this.props.general.account.package.price_norwegian},- NOK</p>
                                :
                                    <p>${this.props.general.account.downgrade_package ? this.props.general.account.downgrade_package.price:this.props.general.account.package.price}</p>
                                }
                            </strong></td>
                        </tr>
                    </tbody>
                </table>
                <div className="col-sm-12 p-0">
					<button className="btn btn-dark btn-block" onClick={(e) => {e.stopPropagation(); this.handleChangePlan()}}>Change plan</button>
				</div>
			</OptionColumn>
			}

					{this.props.general.account.grace_period ?
						null:
					<SplitRows />
					}

					{this.props.general.account.grace_period ?
						null
					:
					<OptionColumn title="Payment card" description="Replace an existing card with a new one.">
						<div className="col-sm-8">
							<input disabled type="text" style={{fontWeight:600,letterSpacing:'2px'}} value={`****-****-****-${this.props.general.account.card_last_four ? this.props.general.account.card_last_four:'****'}`} className="form-control" />
						</div>
						<div className="col-sm-4">
							<button className="btn btn-dark btn-block" onClick={(e) => {e.stopPropagation(); this.handleCard()}}>Change</button>
						</div>
					</OptionColumn>
					}


					{this.props.general.account.grace_period ?
					<SplitRows />
					:null}

					{this.props.general.account.grace_period ?
					<OptionColumn title="Cancel" description="Cancel your current subscription.">

							<div>
								<p>Your subscription at crall will end at <strong>{moment(this.props.general.account.grace_period).format('DD.MM.YYYY')}</strong>, and will not be billed after this date.</p>
								{
									this.state.isResuming ?
									<LoadingSmall />
									:
									<button className="btn btn-success btn-block" onClick={(e) => {e.stopPropagation(); this.handleResume()}}>Resume subscription</button>
								}
							</div>
					</OptionColumn>
					:
					null}

					</div>
		);
	}

	render() {

		if(this.state.isLoading) {
			return <Loading error={false} />
		}

		return (

				<div className="full-height">
				<div className="page-header">
					<span className="page-title"><i className="icon wb-payment"></i> Billing</span>
				</div>

				<div className="page-content">



					{this.renderSubscribed()}

				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
		general:state.general
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({},dispatch)
}


Settings = connect(mapStateToProps,mapDispatchToProps)(Settings);
export default Settings;



// WEBPACK FOOTER //
// ./containers/settings/BillingOverview.js